import React from 'react';
import { observer } from 'mobx-react';

// Translations
import translate from '../Translate.js';

// Components
import * as icons from '../Icons/Icons';

const Toolbar = observer(class Toolbar extends React.Component {
  render() {
    return (
      <div className={`toolbar ${this.props.selectedRows.length === 0 ? 'exiting' : ''}`}>
        <button
          className="btn--outline btn--negative"
          onClick={this.props.deleteFunction}
        >
          <icons.iconTrash />
          {this.props.deleteText}
        </button>
      </div>
    )
  }
})

export default translate('Toolbar')(Toolbar);


// WEBPACK FOOTER //
// ./src/app/components/Common/Toolbar.js